export default {
      id: "oc-icon_reboot-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_reboot",
      toString: function () {
        return this.url;
      }
    }